import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  // Close on Escape key
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setActiveModal(null);
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, []);
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (activeModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [activeModal]);
  const openModal = (type: ModalType) => (e: React.MouseEvent) => {
    e.preventDefault();
    setActiveModal(type);
  };
  return <>
      <footer className="w-full bg-[#0f172a] py-12 border-t border-[#1e293b]" data-id="element-49">
        <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-50">
          <p className="text-[#64748b] text-sm mb-4" data-id="element-51">
            © {new Date().getFullYear()} Der Schnarch- & Nasenfrei-Plan
          </p>
          <div className="flex justify-center items-center space-x-4 text-sm font-medium" data-id="element-52">
            <button onClick={openModal('privacy')} className="text-[#94a3b8] hover:text-[#d4a574] transition-colors duration-200" data-id="element-53">
              Datenschutz
            </button>
            <span className="text-[#334155]" data-id="element-54">•</span>
            <button onClick={openModal('terms')} className="text-[#94a3b8] hover:text-[#d4a574] transition-colors duration-200" data-id="element-55">
              AGB
            </button>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-56">
        {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-57">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setActiveModal(null)} className="absolute inset-0 bg-black/60 backdrop-blur-sm" data-id="element-58" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative w-full max-w-2xl bg-[#1e293b] border border-[#334155] rounded-2xl shadow-2xl overflow-hidden flex flex-col max-h-[85vh]" data-id="element-59">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-[#334155] bg-[#1e293b]" data-id="element-60">
                <h2 className="text-xl font-bold text-[#faf5ef]" data-id="element-61">
                  {activeModal === 'privacy' ? 'Datenschutzerklärung' : 'Allgemeine Geschäftsbedingungen'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-[#334155] text-[#94a3b8] hover:text-[#faf5ef] transition-colors" data-id="element-62">
                  <X className="w-5 h-5" data-id="element-63" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 md:p-8 overflow-y-auto text-[#cbd5e1] leading-relaxed space-y-6 text-sm md:text-base" data-id="element-64">
                {activeModal === 'privacy' ? <>
                    <p data-id="element-65">
                      <strong data-id="element-66">1. Allgemeines</strong>
                      <br data-id="element-67" />
                      Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges
                      Anliegen. Wir verarbeiten Ihre Daten daher ausschließlich
                      auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG
                      2003). In diesen Datenschutzinformationen informieren wir
                      Sie über die wichtigsten Aspekte der Datenverarbeitung im
                      Rahmen unserer Website.
                    </p>
                    <p data-id="element-68">
                      <strong data-id="element-69">2. Datenspeicherung</strong>
                      <br data-id="element-70" />
                      Wir weisen darauf hin, dass zum Zweck des einfacheren
                      Einkaufsvorganges und zur späteren Vertragsabwicklung vom
                      Webshop-Betreiber im Rahmen von Cookies die IP-Daten des
                      Anschlussinhabers gespeichert werden, ebenso wie Name,
                      Anschrift und Kreditkartennummer des Käufers. Die von
                      Ihnen bereitgestellten Daten sind zur Vertragserfüllung
                      bzw. zur Durchführung vorvertraglicher Maßnahmen
                      erforderlich. Ohne diese Daten können wir den Vertrag mit
                      Ihnen nicht abschließen.
                    </p>
                    <p data-id="element-71">
                      <strong data-id="element-72">3. Cookies & Analyse</strong>
                      <br data-id="element-73" />
                      Unsere Website verwendet so genannte Cookies. Dabei
                      handelt es sich um kleine Textdateien, die mit Hilfe des
                      Browsers auf Ihrem Endgerät abgelegt werden. Sie richten
                      keinen Schaden an. Wir nutzen Cookies dazu, unser Angebot
                      nutzerfreundlich zu gestalten. Einige Cookies bleiben auf
                      Ihrem Endgerät gespeichert, bis Sie diese löschen. Sie
                      ermöglichen es uns, Ihren Browser beim nächsten Besuch
                      wiederzuerkennen.
                    </p>
                    <p data-id="element-74">
                      <strong data-id="element-75">4. Ihre Rechte</strong>
                      <br data-id="element-76" />
                      Ihnen stehen grundsätzlich die Rechte auf Auskunft,
                      Berichtigung, Löschung, Einschränkung,
                      Datenübertragbarkeit, Widerruf und Widerspruch zu. Wenn
                      Sie glauben, dass die Verarbeitung Ihrer Daten gegen das
                      Datenschutzrecht verstößt oder Ihre datenschutzrechtlichen
                      Ansprüche sonst in einer Weise verletzt worden sind,
                      können Sie sich bei der Aufsichtsbehörde beschweren.
                    </p>
                  </> : <>
                    <p data-id="element-77">
                      <strong data-id="element-78">1. Geltungsbereich</strong>
                      <br data-id="element-79" />
                      Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für
                      alle Geschäftsbeziehungen zwischen dem Anbieter des
                      "Schnarch- & Nasenfrei-Plans" (nachfolgend "Anbieter") und
                      dem Kunden in der zum Zeitpunkt der Bestellung gültigen
                      Fassung. Abweichende Bedingungen des Kunden werden nicht
                      anerkannt, es sei denn, der Anbieter stimmt ihrer Geltung
                      ausdrücklich schriftlich zu.
                    </p>
                    <p data-id="element-80">
                      <strong data-id="element-81">2. Vertragsgegenstand & Lieferung</strong>
                      <br data-id="element-82" />
                      Gegenstand des Vertrages ist der Verkauf von digitalen
                      Produkten (E-Books, PDF-Dateien, Tracker). Da es sich um
                      digitale Inhalte handelt, die nicht auf einem körperlichen
                      Datenträger geliefert werden, stimmt der Kunde
                      ausdrücklich zu, dass mit der Ausführung des Vertrags vor
                      Ablauf der Widerrufsfrist begonnen wird. Die Lieferung
                      erfolgt unmittelbar nach Zahlungseingang per Download-Link
                      oder E-Mail.
                    </p>
                    <p data-id="element-83">
                      <strong data-id="element-84">3. Haftungsausschluss</strong>
                      <br data-id="element-85" />
                      Die im "Schnarch- & Nasenfrei-Plan" enthaltenen
                      Informationen und Ratschläge wurden sorgfältig
                      recherchiert und geprüft. Dennoch kann keine Garantie für
                      die Richtigkeit, Vollständigkeit und Aktualität übernommen
                      werden. Die Inhalte stellen keine medizinische Beratung,
                      Diagnose oder Behandlung dar und ersetzen nicht den Besuch
                      bei einem Arzt. Die Umsetzung der Ratschläge erfolgt auf
                      eigene Verantwortung des Kunden.
                    </p>
                    <p data-id="element-86">
                      <strong data-id="element-87">4. Urheberrecht</strong>
                      <br data-id="element-88" />
                      Die durch den Anbieter erstellten Inhalte und Werke auf
                      diesen Seiten unterliegen dem Urheberrecht. Die
                      Vervielfältigung, Bearbeitung, Verbreitung und jede Art
                      der Verwertung außerhalb der Grenzen des Urheberrechtes
                      bedürfen der schriftlichen Zustimmung des jeweiligen
                      Autors bzw. Erstellers. Downloads und Kopien dieser Seite
                      sind nur für den privaten, nicht kommerziellen Gebrauch
                      gestattet.
                    </p>
                    <p data-id="element-89">
                      <strong data-id="element-90">5. Gerichtsstand & Anwendbares Recht</strong>
                      <br data-id="element-91" />
                      Es gilt das Recht des Sitzes des Anbieters unter
                      Ausschluss des UN-Kaufrechts. Sofern es sich beim Kunden
                      um einen Kaufmann, eine juristische Person des
                      öffentlichen Rechts oder um ein öffentlich-rechtliches
                      Sondervermögen handelt, ist Gerichtsstand für alle
                      Streitigkeiten aus Vertragsverhältnissen zwischen dem
                      Kunden und dem Anbieter der Sitz des Anbieters.
                    </p>
                  </>}
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>
    </>;
}